/**
 * Accordion block.
 *
 * Each item header toggles its panel. Headers are rendered with
 * role="button" and tabindex="0" (components/accordion/accordion.php), so
 * they also respond to Enter and Space and keep aria-expanded in sync for
 * screen readers.
 */
class Accordion {
	constructor(blockEl) {
		this.accordion = blockEl;
		this.itemHeaders = this.accordion.querySelectorAll('.accordion-container__header');
		this.itemBody = this.accordion.querySelectorAll('.accordion-container__content');

		this.setEventHandlers();
	}

	/**
	 * Open or close one item and update its ARIA state.
	 *
	 * @param {HTMLElement} accHeader The clicked header.
	 * @param {number} index Position of the header, matching its panel.
	 */
	toggleItem(accHeader, index) {
		// Toggle active class just on the clicked header
		const isOpen = accHeader.classList.toggle('active');
		accHeader.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

		// Toggle active class just on the associated content
		const accBody = this.itemBody[index];
		accBody.classList.toggle('active', isOpen);
	}

	setEventHandlers() {
		this.itemHeaders.forEach((accHeader, index) => {
			accHeader.addEventListener('click', () => this.toggleItem(accHeader, index));

			// Keyboard support for the role="button" header.
			accHeader.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					this.toggleItem(accHeader, index);
				}
			});
		});
	}

}

export default Accordion;
